import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { setCsrfToken } from '../../utils/csrfTokenStore'
import { initSentry } from '../../utils/sentry'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../PartnerOptions/constants'
import { selectCompanyFilter } from '../PartnerOptions/selectors'
import { MAKE_OWNER_ASYNC } from '../Settings/Users/constants'

import {
  fetchAppDataError,
  fetchAppDataSuccess,
  refetchOwnerStatusError,
  refetchOwnerStatusSuccess,
} from './actions'
import {
  DISMISS_NOTIFICATION_ASYNC,
  FETCH_APP_DATA_ASYNC,
  FETCH_APP_NOTIFICATIONS_ASYNC,
  REFETCH_APP_DATA_ACTIONS,
} from './constants'

const fetchAppDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_APP_DATA_ASYNC.INITIATE, ...REFETCH_APP_DATA_ACTIONS),
    mergeMap(() =>
      api.accounts.getStatus().pipe(
        map((status) => {
          if (status.csrfToken) {
            setCsrfToken(status.csrfToken)
          }
          initSentry(status.environment)
          return fetchAppDataSuccess(status)
        }),
        catchError((error) => of(epicsErrorHandler(fetchAppDataError, error, []))),
        takeUntil(action$.pipe(ofType(FETCH_APP_DATA_ASYNC.CANCEL)))
      )
    )
  )

const fetchAppNotificationsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    // eslint-disable-next-line ironscales/fetch-selected-company-filter-guard -- app notifications render in the top bar on every route, so a URL guard would leave the bell showing the previous company's notifications
    ofType(FETCH_APP_DATA_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS),
    mergeMap(() => {
      const companyFilter = selectCompanyFilter(state$.value)?.value
      return api.accounts.getNotifications(companyFilter).pipe(
        map((notifications) => FETCH_APP_NOTIFICATIONS_ASYNC.onSuccess(notifications)),
        catchError((error) =>
          of(epicsErrorHandler(FETCH_APP_NOTIFICATIONS_ASYNC.onError, error, []))
        ),
        takeUntil(
          action$.pipe(ofType(FETCH_APP_NOTIFICATIONS_ASYNC.CANCEL, FETCH_APP_DATA_ASYNC.CANCEL))
        )
      )
    })
  )

const refetchOwnerStatusEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(MAKE_OWNER_ASYNC.SUCCESS),
    mergeMap(() =>
      api.accounts.getOwnerStatus().pipe(
        map((response) => refetchOwnerStatusSuccess(response)),
        catchError((error) => of(epicsErrorHandler(refetchOwnerStatusError, error))),
        takeUntil(action$.pipe(ofType(MAKE_OWNER_ASYNC.CANCEL)))
      )
    )
  )

const dismissNotificationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DISMISS_NOTIFICATION_ASYNC.INITIATE),
    mergeMap((action) =>
      api.accounts.dismissNotification(action.payload).pipe(
        map((response) => DISMISS_NOTIFICATION_ASYNC.onSuccess(response)),
        catchError((error) => of(epicsErrorHandler(DISMISS_NOTIFICATION_ASYNC.onError, error))),
        takeUntil(action$.pipe(ofType(DISMISS_NOTIFICATION_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpicsIsolated(
  fetchAppDataEpic,
  fetchAppNotificationsEpic,
  refetchOwnerStatusEpic,
  dismissNotificationEpic
)
